<template>
  <div class="c-entrepreneur-title-text">
    <div class="c-entrepreneur-title-text__inner">
      <!-- ici maintenant -->
      <entrepreneur-title-text-hero :data="data.primary" :is-icon-visible="isIconVisible(data.primary.icon)" />
      <!-- copy -->
      <entrepreneur-title-text-copy :data="data.primary" />
    </div>
  </div>
</template>

<script>
import EntrepreneurTitleTextCopy from "components/EntrepreneurTitleText/EntrepreneurTitleTextCopy";
import EntrepreneurTitleTextHero from "src/templates/components/EntrepreneurTitleText/EntrepreneurTitleTextHero";
export default {
  components: {
    EntrepreneurTitleTextCopy,
    EntrepreneurTitleTextHero
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    isIconVisible(val) {
      return val === "Yes";
    }
  }
};
</script>

<style lang="scss">
.c-entrepreneur-title-text {
  @include sectionColouredPadding;
  display: flex;
  flex-direction: row;
  height: 100%;

  @media #{$breakpoint-horizontal} {
    margin-bottom: 3em; //I am not sure why there is a margin at the top, so I will add one at the bottom too */
  }
  &__inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 0px var(--grid-gutter); */
    flex-direction: column;
    @media #{$breakpoint-horizontal} {
      flex-direction: row;
    }
  }
}
</style>
